export const init = {
	activeAttributes: [],
	activeDropAuction: null,
	auctionReminder: {status: false},
	isAuctionStart: false,
	auctionTenMinLeft: false,
	addedCartProduct: null,
	brandGuide: null,
	retailerGuide: null,
	charities: [],
	dropAuctionStockAvailable: false,
	deliveryArea: {
		countryCode: null,
		stateCode: null,
	},
	error: {},
	errorResponse: '',
	goodCauseValue: 0,
	isAvailableStock: false,
	isBtnClicked: false,
	isSeeOptionActive: false,
	hasMultiPricing: true,
	instantBidTries: 0,
	newAttributeData: [],
	openBagModal: false,
	retailer: null,
	quantity: 1,
	rrp: 0,
	selectedOptions: {},
	selectedOptionAttr: [],
	selectedStoreShop: null,
	selectedImage: null,
	selectedVariance: null,
	selectedPaymentOption: null,
	selectedShippingOption: null,
	selectedGoodCause: null,
	settings: null,
	sizeGuide: null,
	showPromoPopup: false,
	showAuctionBlock: false,
	showGuideModal: false,
	showShippingModal: false,
	showPaymentModal: false,
	showGoodCauseModalOne: false,
	showGoodCauseModalTwo: false,
	showBuyBeforeAuctionModal: false,
	showAddressModal: false,
	storePrices: [],
	stockError: {},
	strikeThroughPrice: 0,
	tabs: [],
	cart: [],
	varianceName: null,
	vName: {},
	pictures: [],
	picIndex: 0,
	loading: false,
	customerAddress: {},
	customerAddressText: '',
	retailerAddress: {},
	retailerAddressText: '',
	addToCart: false,
	isInstantBidButtonClicked: false,
	wishlistData: '',
	auctionDuration: null,
	// Note: here data will be stored in the form of objects,
	// that will be retailer id is key and data will be array
	// of countries. eg. {"retailerId":['Australia','New Zealand']}
	availableShippingCountries: {},
	unavailableShippingCountries: {},
	ageVerification: {},
};

export const reducer = (state, action) => {
	switch (action.type) {
		case 'setData':
			return {
				...state,
				...action.data,
			};
		case 'set_size_guide':
			return {
				...state,
				sizeGuide: action.sizeGuide,
			};
		case 'error':
			return {
				...state,
				messageKey: 'error',
				message: action.message,
			};
		case 'setLoading':
			return {
				...state,
				loading: action.value,
			};
		case 'set_attributes':
			return {
				...state,
				newAttributeData: action.value,
			};
		case 'set_quantity':
			return {
				...state,
				quantity: action.value,
				stockError: {},
			};
		case 'set_modal_visibiilty': {
			const key =
				action.name === 'promo'
					? 'showPromoPopup'
					: action.name === 'guide'
					? 'showGuideModal'
					: 'openBagModal';

			return {
				...state,
				[key]: action.value,
			};
		}
		case 'onSelectVariance':
			return {
				...state,
				...action.data,
			};
		case 'setAuctionReminder':
			return {
				...state,
				...action.data,
			};

		default:
			return state;
	}
};
